import styled from 'styled-components';

import { get } from '../../../common/ui/get';

export const CheckmarkIcon = styled.div`
    color: ${get('colors.foreground.onEmphasis')};
    width: 18px;
    height: 18px;
`;
